import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import cx from 'clsx';
import message from 'antd/es/message';

import { IconRcMore } from '@/assets/nft';
import { NftToken } from '@/views/NFT';
import { Dropdown } from '@/components';

import { useCollectionRefresh } from '../../hooks';
import style from './index.module.scss';

export const NftMoreDropdown = ({
  chainId,
  nftId,
  className,
  onSuccess,
}: {
  chainId: string;
  nftId: string;
  className?: string;
  onSuccess?: (data?: { nft: NftToken }) => void;
}) => {
  const { t } = useTranslation();

  const { mutateAsync } = useCollectionRefresh();

  const handleRefreshCollection = useCallback(async () => {
    if (chainId && nftId) {
      message.info(t('NftMoreDropdown.updating'));
      try {
        const res = await mutateAsync({
          chain_id: chainId,
          nft_id: nftId,
        });
        onSuccess?.(res);
      } catch (error) {}
    }
  }, [mutateAsync, chainId, nftId, onSuccess, t]);

  const menus = useMemo(
    () =>
      chainId && nftId
        ? [
            {
              label: t('NftMoreDropdown.zmi038'),
              onClick: async () => {
                handleRefreshCollection();
              },
            },
          ]
        : undefined,
    [handleRefreshCollection, chainId, nftId, t],
  );

  return (
    <div className={cx(style.more, className)}>
      <Dropdown data={menus} inParent className={style.dropdown} trigger={['click']}>
        <IconRcMore />
      </Dropdown>
    </div>
  );
};
